import React, { useEffect, useState } from "react";
import { View } from "react-native";

import FilterModal from "./EventsTab/Components/FilterModal";

import Header from "@/Components/Headers/Components/Header";
import { useHeaderContext } from "@/context/header/useHeaderContext";
import { type EventFilterCriteria } from "@/schemas/events/filter/EventFilterCriteria";
import { type ContentScreenState } from "@/schemas/screen/configs";
import { ContentTabs, Screen } from "@/schemas/screen/tabs";
import { countActiveFilters } from "@/utils/filters";
import FilterIcon from "@/Components/Icons/FilterIcon";

function ContentFeedHeader(): React.JSX.Element {
  const { currentScreen, setCurrentScreen } = useHeaderContext();

  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [activeFiltersCount, setActiveFiltersCount] = useState<number>(0);

  const [currentTab, setCurrentTab] = useState<ContentTabs>(ContentTabs.EVENTS);

  const openFilterModal = (): void => {
    setIsFilterModalVisible(true);
  };

  const closeFilterModal = (): void => {
    setIsFilterModalVisible(false);
  };

  useEffect(() => {
    if (currentScreen.screenId === Screen.CONTENT) {
      setCurrentTab(currentScreen.activeTabId);
      setActiveFiltersCount(countActiveFilters(currentScreen.filters));
    }
  }, [currentScreen]);

  function handleApplyFilters(newFilters: EventFilterCriteria): void {
    if (currentScreen.screenId === Screen.CONTENT) {
      const newEventTabConfig: ContentScreenState = {
        screenId: Screen.CONTENT,
        activeTabId: currentScreen.activeTabId,
        filters: newFilters,
      };
      setCurrentScreen(newEventTabConfig);
    }

    closeFilterModal();
  }

  const handleTabPress = (tab: ContentTabs): void => {
    if (currentTab !== tab) {
      const newTab: ContentScreenState = {
        screenId: Screen.CONTENT,
        activeTabId: tab,
        filters: null,
      };
      setCurrentScreen(newTab);
    }
  };

  return (
    <View>
      <Header
        tabs={[
          {
            isActive: currentTab === ContentTabs.EVENTS,
            onPress: () => handleTabPress(ContentTabs.EVENTS),
            title: "Events",
          },
        ]}
        rightComponent={
          currentTab === ContentTabs.EVENTS && (
            <FilterIcon
              filterCount={activeFiltersCount}
              onPress={openFilterModal}
            />
          )
        }
      />
      <FilterModal
        isModalVisible={isFilterModalVisible}
        onApplyFilters={handleApplyFilters}
        onClose={closeFilterModal}
      />
    </View>
  );
}

export default ContentFeedHeader;
